import React from 'react';

const FraudProtectionIcon = props => {
  return (
    <svg x="0px" y="0px" viewBox="0 0 42 42" className={props.className}>
      <g>
        <path
          style={{ fill: '#969696' }}
          d="M17.9,25.8c-0.2,0.1-0.5,0.2-0.8,0.4c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.5,0.1-0.8,0.2
          c-0.7,0.1-1.4,0.2-2.2,0.2c-0.8,0-1.5-0.1-2.2-0.2c-1.7-0.3-2.9-0.9-3.3-1.6c-0.1-0.1-0.1-0.3-0.1-0.5v-2.2c0,1.2,2.5,2.2,5.6,2.2
          c1.8,0,3.5-0.4,4.5-0.9v-1.1c-1,0.5-2.6,0.9-4.5,0.9c-3.1,0-5.6-1-5.6-2.2v-2.2c0,1.2,2.5,2.2,5.6,2.2c1.8,0,3.5-0.4,4.5-0.9v-1.1
          c-1,0.5-2.6,0.9-4.5,0.9c-3.1,0-5.6-1-5.6-2.2v-2.2c0,1.2,2.5,2.2,5.6,2.2c3.1,0,5.6-1,5.6-2.2v1.3l1.1-0.4v-2c0,0,0,0,0,0
          c0.4,0,0.7,0,1.1,0c3.1,0,5.6-1,5.6-2.2V14c0.1,0,0.3,0,0.4,0.1l0.4,0.1v-2v0V11v0V8.8v0V7.7v0c0-0.8-0.5-1.4-1.2-1.9c0,0,0,0,0,0
          c-0.1-0.1-0.2-0.1-0.4-0.2c-1.2-0.6-3-1-4.8-1c-1.5,0-3.1,0.2-4.3,0.7c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0,0
          c-1.1,0.5-1.8,1.2-1.8,2.2c0,0,0,0,0,0v1.1l0,0V11c0,0,0,0,0,0v0.4c0,0,0,0-0.1,0c-0.2,0-0.4,0-0.6,0c0,0-0.1,0-0.1,0
          c-0.2,0-0.4,0-0.7,0h0c-2.9,0-5.8,0.9-6.3,2.5C7,14,7,14.2,7,14.4v1.1v2.2v1.1v2.2v1.1v2.2c0,0.1,0,0.1,0,0.2
          c0,0.3,0.1,0.5,0.3,0.7c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2
          C8,26.2,8,26.2,8.1,26.3c0.3,0.2,0.6,0.3,0.9,0.5c0.4,0.2,0.8,0.3,1.3,0.4c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.1,0,0.2,0
          c0.1,0,0.3,0,0.4,0.1c0.6,0.1,1.2,0.1,1.8,0.1c0.6,0,1.2,0,1.8-0.1c1-0.1,1.9-0.4,2.7-0.7V25.8z M15.7,7.7c0-0.9,1.3-1.6,3.1-2
          c0.8-0.2,1.6-0.2,2.5-0.2c1.3,0,2.5,0.2,3.4,0.5c1.3,0.4,2.2,1,2.2,1.8v0c0,1.2-2.5,2.2-5.6,2.2C18.2,9.9,15.7,8.9,15.7,7.7
          L15.7,7.7z M15.7,11V8.8c0,1.2,2.5,2.2,5.6,2.2c3.1,0,5.6-1,5.6-2.2V11v0c0,1.2-2.5,2.2-5.6,2.2c-0.5,0-1.1,0-1.6-0.1
          c-0.7-0.9-2.2-1.6-4-1.9C15.7,11.2,15.7,11.1,15.7,11L15.7,11z M8.1,13.7c0.7-0.9,2.8-1.6,5.3-1.6c0,0,0,0,0,0c0.2,0,0.4,0,0.5,0
          c0,0,0.1,0,0.1,0c0.2,0,0.3,0,0.5,0c0,0,0,0,0,0c0.4,0,0.7,0.1,1,0.1c2,0.3,3.4,1.1,3.4,2.1c0,1.2-2.5,2.2-5.6,2.2
          c-3.1,0-5.6-1-5.6-2.2C7.8,14.2,7.9,14,8.1,13.7"
        />
        <path
          style={{ fill: '#32B496' }}
          d="M34.7,19L27,16.1c-0.1,0-0.2,0-0.3,0L19,19c-0.2,0.1-0.3,0.2-0.3,0.4v9.4c0,1.6,0.8,3.1,2.6,4.7
          c1.3,1.1,2.9,2.2,4.5,3.3c0.3,0.2,0.5,0.3,0.8,0.5c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0.3-0.2,0.5-0.3,0.8-0.5
          c1.6-1,3.2-2.1,4.5-3.3c1.8-1.6,2.6-3.1,2.6-4.7v-9.4C35,19.2,34.9,19.1,34.7,19 M33.3,28.8c0,1.1-0.7,2.2-2.1,3.5
          c-1.2,1.1-2.8,2.1-4.3,3.1l-0.1,0.1l-0.1,0l0,0c-1.5-1-3.1-2.1-4.3-3.1c-1.4-1.3-2.1-2.4-2.1-3.5v-2.5h13V28.8z"
        />
      </g>
    </svg>
  );
};

export default FraudProtectionIcon;
